module.exports = __webpack_public_path__ + "images/emoji/sunglasses.4c43467603ddf68a5edb.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/sunglasses.png
// module id = wGTa
// module chunks = 1